<template>
	<v-layout row wrap white class="section-how-it-work" id="stepbystep">
		<v-flex xs12>
			<v-layout row wrap>
				<v-flex xs12 md6 secondary--text class="section-how-it-work-title">
					<h3>¿Cómo funciona</h3>
					<h2>CASAMARKET?</h2>
				</v-flex>
				<v-flex xs12 md6 info--text class="section-how-it-work-subtext">
					<p>
						Amigo bodeguero, te queremos mostrar lo sencillo que es usar CasaMarket;
						prepárate para añadir a tu negocio una potente herramienta de tecnología:
					</p>
				</v-flex>
			</v-layout>
			<v-layout row wrap v-for="step in steps" :key="step.id" class="steps-container">
				<v-flex xs12 md6 class="container-step-image" :class="{ 'order-md6': step.position }">
					<img :src="step.image" :class="step.class">
					<v-layout row wrap primary--text class="step-title-container">
						<v-flex xs2 class="step-number-secondary">
							{{ step.number }}
						</v-flex>
						<v-flex xs10>
							<h3 class="step-title">{{ step.title }}</h3>
							<template v-if="step.text">
								<p
									class="step-text info--text"
									:class="{ 'no-margin': step.list }"
								>
									{{ step.text }}
								</p>
							</template>
							<template v-if="step.list">
								<template v-for="(item, index) in step.list">
									<p
										:key="index"
										class="step-list info--text"
										:class="{ 'margin': step.list }"
									>
										- {{ item }}
									</p>
								</template>
							</template>
						</v-flex>
					</v-layout>
				</v-flex>
				<v-flex xs12 md6>
					<div class="step-image-container">
						<div class="step-number">{{ step.number }}</div>
						<img
							:src="step.gif"
							alt="tu cliente realiza el pedido"
							height="588"
							class="step-gif"
						/>
						<img
							src="/static/images/sections/step-cel.png"
							alt="tu cliente realiza el pedido"
							height="592"
							class="step-image-cel"
						/>
					</div>
				</v-flex>
			</v-layout>
			<v-layout row wrap class="component-desktop">
				<v-flex xs12 text-xs-center>
					<a :href="landingLink" target="_blank" class="text-decoration-none">
						<v-btn
							class="btn-action btn-auto section-how-it-work-btn white--text"
							color="primary"
							depressed
						>
							SOLICITA TU APP
						</v-btn>
					</a>
				</v-flex>
			</v-layout>
		</v-flex>
	</v-layout>
</template>

<script>
	function data() {
		return {
			landingLink: process.env.ORDER_LINK,
			steps: [
				{
					id: 1,
					class: 'step-image-1',
					gif: 'https://media.giphy.com/media/ZBKbRBelpwg9LGlZAf/giphy.gif',
					image: '/static/images/sections/step-1.png',
					number: 1,
					position: true,
					text: 'A través de tu aplicativo tus clientes podrán hacer sus pedidos: así de fácil.',
					title: 'Tu cliente realiza el pedido',
				},
				{
					id: 2,
					class: 'step-image-2',
					gif: 'https://media.giphy.com/media/PhBSL6TvxLb9dqiltL/giphy.gif',
					image: '/static/images/sections/step-2.png',
					list: ['Por entregar', 'Listo para entrega', 'Entregado'],
					number: 2,
					position: false,
					text: 'Puedes recibir tus pedidos y filtrarlos:',
					title: 'Recibes el pedido de inmediato',
				},
				{
					id: 3,
					class: 'step-image-3',
					gif: 'https://media.giphy.com/media/dsv0eAsC1naOjnc8Aj/giphy.gif',
					image: '/static/images/sections/step-3.png',
					list: [
						'Alistar tu pedido y lo pones en cola de entrega para que el usuario solo tenga que recoger su pedido o esperarlo en su domicilio.',
						'Aquí no te preocupes por el pago porque el usuario puede efectuar su pago a través de distintas plataformas online, o hace el pago efectivo. Como mejor te acomode.',
					],
					number: 3,
					position: true,
					title: 'Preparas tu pedido',
				},
				{
					id: 4,
					class: 'step-image-4',
					gif: 'https://media.giphy.com/media/SXIW01sfEu953X6FD6/giphy.gif',
					image: '/static/images/sections/step-4.png',
					number: 4,
					position: false,
					text: 'Pedido listo para entrega en la modalidad que el cliente elija. Cliente Satisfecho.',
					title: 'Listo, confirmar para entrega',
				},
			],
		};
	}

	export default {
		name: 'section-how-ir-work',
		data,
	};
</script>

<style lang="scss" scoped>
	.section-how-it-work {
		padding: 49px 2% 81px;
		text-align: center;

		@media (min-width: 1024px) {
			padding: 66px 8% 74px;
			text-align: left;
		}

		@media (min-width: 1280px) {
			padding: 66px 10% 74px;
		}

		&-title {
			line-height: 1;

			@media (min-width: 1024px) {
				border-right: 2px solid color(secondary);
				padding-right: 28px;
				text-align: right;
			}

			h3 {
				font-size: size(large30);
				font-weight: weight(w900);
				text-transform: uppercase;
			}

			h2 {
				font-size: size(large47);
				font-weight: weight(w900);
			}
		}

		&-subtext {
			p {
				font-size: size(medium18);
				line-height: 23px;
				margin: 47px auto 72px;
				max-width: 287px;

				@media (min-width: 1024px) {
					margin: 15px 0px 0px 38px;
					max-width: none;
				}
			}
		}

		&-btn {
			border-radius: 8px;
			font-size: size(medium20);
			font-weight: 600;
			height: 60px !important;
			width: 271px !important;
		}
	}

	.step-image-container {
		margin: auto;
		position: relative;
		width: fit-content;
		width: -moz-fit-content;
		width: -webkit-fit-content;
	}

	.step-gif {
		border-radius: 16px;
		height: 539px;
		left: 0px;
		margin: auto;
		position: absolute;
		right: 0px;
		top: 15px;
		width: 258px;
	}

	.step-image-1 {
		height: 195px;
		margin-bottom: 31px;

		@media (min-width: 1024px) {
			height: 239px;
			margin-bottom: 26px;
			margin-top: 267px;
		}
	}

	.step-image-2 {
		height: 196px;
		margin-bottom: 31px;

		@media (min-width: 1024px) {
			height: 241px;
			margin-bottom: 26px;
			margin-top: 207px;
		}
	}

	.step-image-3 {
		height: 194px;
		margin-bottom: 31px;

		@media (min-width: 1024px) {
			height: 243px;
			margin-bottom: 26px;
			margin-top: 207px;
		}
	}

	.step-image-4 {
		height: 196px;
		margin-bottom: 31px;

		@media (min-width: 1024px) {
			height: 243px;
			margin-bottom: 26px;
			margin-top: 207px;
		}
	}

	.step-title {
		border-bottom: 3px solid color(success);
		font-size: size(medium20);
		font-weight: weight(w900);
		padding-bottom: 12px;
		text-align: left;

		@media (min-width: 1024px) {
			font-size: size(large25);
		}
	}

	.step-text {
		font-size: size(medium16);
		font-weight: weight(w600);
		line-height: 1;
		margin-bottom: 65px;
		margin-top: 21px;
		text-align: left;

		&.no-margin {
			margin-bottom: 20px;
		}

		@media (min-width: 1024px) {
			font-size: size(medium18);
		}
	}

	.step-list {
		font-size: size(medium16);
		font-weight: weight(w600);
		margin-bottom: 0px;
		text-align: left;

		&:last-of-type {
			&.margin {
				margin-bottom: 65px;
			}
		}
	}

	.step-number-secondary {
		font-size: size(large60);
		font-weight: weight(w900);
		line-height: normal;

		@media (min-width: 1024px) {
			font-size: size(large77);
			line-height: 0.8;
		}
	}

	.step-number {
		display: none;

		@media (min-width: 1024px) {
			color: rgba(177, 220, 3, 0.1);
			display: initial;
			font-size: size(big);
			font-weight: weight(w900);
			left: -59%;
			position: absolute;
			z-index: 1;
		}
	}

	.component-desktop {
		display: none;

		@media (min-width: 1024px) {
			display: initial;
		}
	}

	.steps-container {
		.step-image-container {
			margin-bottom: 107px;

			@media (min-width: 1024px) {
				margin-top: 166px;
			}
		}

		&:nth-child(3) {
			.step-image-container {
				@media (min-width: 1024px) {
					margin-top: 106px;
				}
			}

			.step-number {
				@media (min-width: 1024px) {
					left: auto;
					right: -50%;
				}
			}
		}

		&:nth-child(4) {
			.step-image-container {
				@media (min-width: 1024px) {
					margin-top: 106px;
				}
			}
		}

		&:nth-child(5) {
			.step-image-container {
				margin-bottom: 0px;

				@media (min-width: 1024px) {
					margin-bottom: 175px;
					margin-top: 106px;
				}
			}

			.step-number {
				@media (min-width: 1024px) {
					left: auto;
					right: -50%;
				}
			}
		}
	}

	.step-title-container {
		@media (min-width: 768px) {
			margin: auto;
			max-width: 60%;
		}

		@media (min-width: 1024px) {
			margin: 0;
			max-width: none;
		}
	}

	.container-step-image {
		@media (min-width: 1024px) {
			text-align: center;
		}
	}

	.text-decoration-none {
		text-decoration: none;
	}
</style>


// WEBPACK FOOTER //
// src/components/home/section-how-it-work.vue